/**
 * Created by han on 1/16/2019.
 */

require('./closest');
require('./assign');
require('./hasAttribute');
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();